'use client';

import { useDiscountsContext } from '@/providers/DiscountProvider';

export function useDiscounts() {
  return useDiscountsContext();
}
